// extracted by mini-css-extract-plugin
export default {"login_btn":"Login_login_btn__xNwJ6","login_card":"Login_login_card__-PE7P"};